export const resolveSupportingPanelMinSize = (args: {
  direction: "vertical" | "horizontal";
  width: number | undefined;
  height: number | undefined;
  minHeight: number | undefined;
  minWidth: number | undefined;
}) => {
  if (args.direction === "vertical") {
    if (args.height === undefined || args?.minHeight === undefined) {
      return undefined;
    }
    if (args?.minHeight > args.height) {
      return undefined;
    }
    return (args?.minHeight / args.height) * 100;
  } else {
    if (args.width === undefined || args?.minWidth === undefined) {
      return undefined;
    }
    if (args?.minWidth > args.width) {
      return undefined;
    }
    return (args?.minWidth / args.width) * 100;
  }
};
